
    var riot = require('riot')
    import modalMixin from 'static/script/app/ui/mixin/modal-mixin';
riot.tag2('contact-modal-form', '<div name="modalBackground" class="modal-background-without-transition modal-default" data-modal-background data-modal-close-trigger riot-style="z-index: 10000; height: {modalHeight}px" data-clickable-list-ignore-click onclick="{onClose}" if="{showModal}"> <div name="modal" class="modal" data-modal> <button class="modal-close" onclick="{onClose}"></button> <div class="messaging-modal-body"> <h2 class="messaging-modal-title">{modalTitle}</h2> <div class="messaging-modal-info"> <figure class="messaging-modal-item-figure"> <div> <img riot-src="{itemImageUrl}" alt="{itemTitle}"> </div> </figure> <div class="messaging-modal-info-content"> <h2 class="messaging-modal-info-content-title"> {itemTitle} </h2> <time class="messaging-modal-info-content-time">{itemEnddate}</time> <span class="messaging-modal-info-content-object-number"> <strong>Objektnr:</strong> {itemId}</span> </div> </div> <div class="messaging-modal-warning" if="{businessWarning}"> <span class="messaging-modal-warning-icon warning--before"></span> <p class="messaging-modal-warning-body"> <strong>Viktigt!</strong> Det är inte tillåtet att föreslå handel av detta objekt utanför Tradera. Sådana affärer strider mot våra regler och kan leda till avstängning. </p> </div> <dl class="messaging-modal-fromto"> <dt>Från:</dt> <dd>{senderMemberAlias || senderMemberEmail}</dd> <dt>Till:</dt> <dd>{receiverMemberAlias}</dd> <dt>Titel:</dt> <dd>{messageSubject}</dd> </dl> <p class="validation-error-text" if="{hasValidationError}">{warningmessage}</p> <textarea class="input-text messaging-modal-message {hasValidationError ? \'input-text-validation-error\': \'\'}" name="message" placeholder="Skriv ditt meddelande här..." tabindex="0" onkeyup="{edit}"></textarea> <div class="messaging-modal-cc"> <label> <input type="checkbox" id="sendCopytoSender" name="sendCopytoSender"> Skicka kopia till mig </label> <label tabindex="0" for="sendCopytoSender" onkeydown="{onSellerCopyToggle}"></label> </div> <button class="secondary-action messaging-modal-message-action" tabindex="0" onclick="{onSend}" __disabled="{sendButtonDisabled}">Skicka meddelande</button> <button class="default-action messaging-modal-message-action" tabindex="0" onclick="{onCancel}">Avbryt</button> </div> </div> </div>', '', '', function(opts) {
        this.mixin(modalMixin);

        this.messageMaxLength = 1000;
        this.hasValidationError = false;
        this.validator = this.opts.validator;

        this.init = function(payload) {
            this.modalTitle = payload.payload.modalTitle;
            this.itemId = payload.payload.itemId;
            this.receiverMemberId = payload.payload.receiverMemberId;
            this.senderMemberEmail = payload.payload.senderMemberEmail;
            this.senderMemberAlias = payload.payload.senderMemberAlias;
            this.itemTitle = payload.payload.itemTitle;
            this.messageSubject = payload.payload.messageSubject;
            this.itemEnddate = payload.payload.itemEnddate;
            this.itemImageUrl = payload.payload.itemImageUrl;
            this.receiverMemberAlias = payload.payload.receiverMemberAlias;
            this.businessWarning = payload.payload.businessWarning;
            this.sendButtonDisabled = true;
            this.show(true);
            this.update();
        }.bind(this);

        this.updateReceiver = function(receiverInfo) {
            this.sendButtonDisabled = false;
            this.receiverMemberId = receiverInfo.id;
            this.receiverMemberAlias = receiverInfo.alias;
            this.update();
        }.bind(this);

        this.hasInvalidLength = function(msg) {
            return this.validator.hasInvalidLength(0, this.messageMaxLength, msg);
        }.bind(this);

        this.beforeShow = function() {
            if (!this.hasInvalidLength(this.message.value)) {
                this.sendButtonDisabled = false;
                this.update();
            }
            this.firstShowing = true;
        }.bind(this);

        this._reset = function() {
            this.message.value = '';
            this.sendButtonDisabled = true;
            this.hasValidationError = false;
            this.sendCopytoSender.checked = false;
            this.update();
        }.bind(this);

        this.edit = function() {
            var msg = this.message.value;
            var hasError = false;
            this.warningmessage = '';

            if (this.validator.isEmpty(msg)) {
                hasError = true;
                this.warningmessage = 'Du måste ange ett meddelande'
            }
            else if (this.hasInvalidLength(msg)) {
                hasError = true;
                this.warningmessage = 'Meddelandet får maximalt innehålla 1000 tecken';
            }
            else if (this.validator.hasInvalidCharacters(msg)) {
                hasError = true;
                this.warningmessage = 'Tillåtna tecken förutom bokstäver och siffror är " \' ´ ` ! ? , . ; : - ( ) / + - € $';
            }

            this.hasValidationError = hasError;
            this.sendButtonDisabled = hasError;

            this.update();
        }.bind(this);

        this.onSend = function() {

            this.sendButtonDisabled = true;
            this.update();
            this.bus.trigger('ui:contact-modal:on-send', {
                itemId: this.itemId,
                receiverMemberId: this.receiverMemberId,
                message: this.message.value,
                sendCopytoSender: this.sendCopytoSender.checked,
            });
        }.bind(this);

        this.onCancel = function(evt) {
            if (this.message.value.length === 0) {
                this.bus.trigger('ui:contact-modal:on-abort');
            }
            else {
                this.bus.trigger('ui:contact-modal:on-form-close', evt);
            }
        }.bind(this);

        this.onSellerCopyToggle = function(evt) {
            if (evt.keyCode === 32) {
                evt.target.click();
                return false;
            }

            return true;
        }.bind(this);

        this.showForm = function(payload) {
            if (payload !== null) {
                this.updateReceiver(payload);
            };

            this.show();
        }.bind(this);

        this.on('updated', function () {
            if (this.firstShowing) {
                this.message.focus();
                this.firstShowing = false;
            }
        });

        this.on('mount', function () {
            this.bus.on('ui:contact-modal:on-init', this.init);
            this.bus.on('ui:contact-modal:on-retry', this.showForm);
            this.bus.on('data:contact-service:message-sent-success', this.hide);
            this.bus.on('data:contact-service:message-sent-failed', this.hide);
            this.bus.on('ui:contact-modal:on-form-close', this.hide);
            this.bus.on('ui:contact-modal:on-close', function () {
                this.close();
                this._reset();
            }.bind(this));
            this.bus.on('ui:modal-container:after-close', this._reset);
        });
});

    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal-form.riot.html